import Vue from "vue";

export default {
    async getGameProvidersAsync() {
        return (await Vue.http.get("/api/referral/gameproviders")).data;
    }
};


// WEBPACK FOOTER //
// ./src/services/referral.service.js